module.exports = "pegasus_template/assets/themelp1/health/100.png";